import dynamic from "next/dynamic";

const DateStartEndTimePicker = dynamic(
  () => import("./date-start-end-picker"),
  { ssr: false }
);

export default DateStartEndTimePicker;
